import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import styles from "assets/jss/components/customcomponents/typographyStyle.js";

const useStyles = makeStyles(styles);

export default function Info(props) {
  const classes = useStyles();
  const { children,style,className } = props;

  const infoTextClasses = classNames({
    [classes.defaultFontStyle]: true,
    [classes.infoText]: true,
    [className]: className
  });

  return (
    <div className={infoTextClasses} style={style}>
      {children}
    </div>
  );
}

Info.propTypes = {
  children: PropTypes.node,
  style:PropTypes.object,
  className: PropTypes.string,
};
